<template>
  <ErrorLayout
    :btnTexto="btnTexto"
    :showBtn="showBtn"
    :texto="texto"
    :titulo="titulo"
    :svgNome="svgNome"
    @click="$emit('click')"
  />
</template>

<script>
import ErrorLayout from '@/components/Error/ErrorLayout'

export default {
  name: 'ErrorInternet',
  components: { ErrorLayout },
  props: {
    svgNome: {
      type: String,
      default: 'ErrorWifiSvg'
    },
    titulo: {
      type: String,
      default: 'Nenhum item cadastrado'
    },
    texto: {
      type: String,
      default: 'Ainda não foi cadastrado nenhum item para exibir.'
    },
    showBtn: {
      type: Boolean,
      default: true
    },
    btnTexto: {
      type: String,
      default: 'Tentar novamente'
    }
  }
}
</script>

<style scoped>

</style>
